// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footerImage":"babylist-babes__footerImage__2N9Ay"};